<div class="applications">
    <div class="applications__list">
        @for (application of vacancyApplications$ | async; track $index) {
            <div class="application">
                <div class="application__main">
                    @if (application.announcementStatus == announcementStatus.Active) {
                        <a class="application__title application__title--link"
                           [routerLink]="['/announcement', application.announcementId]">{{ application.title }}</a>
                    } @else {
                        <span class="application__title">{{ application.title }}</span>
                    }

                    @if (!application.isCustomerAnonymous && application.customerStatusId == customerStatus.Active) {
                        <a class="application__customer application__customer--link"
                           [routerLink]="['/customer', application.customerId]">{{ application.customerName }}</a>
                    } @else {
                        <span class="application__customer">{{ application.customerName }}</span>
                    }
                </div>

                <div class="application__dates">
                    <span class="application__period">
                        {{ application.announcementPublishDate | date:'M/d/yy' }} - {{ application.announcementDeadlineDate | date:'M/d/yy' }}
                    </span>
                    <span class="application__date">
                        {{ 'label.ApplicationDate' | translate }}: {{ application.applicationDate | date:'M/d/yy' }}
                    </span>
                </div>

                <div class="application__status">
                    <span class="status"
                          [class.status--approved]="application.applicationStatus == applicationStatus.Approved"
                          [class.status--rejected]="application.applicationStatus == applicationStatus.Rejected">
                        {{ applicationStatusNameMap[application.applicationStatus] | translate }}
                    </span>
                </div>
            </div>
        }
    </div>

    @if ((vacancyApplications$ | async)?.length > 0) {
        @if ({ pageCount: pageCount$ | async, navItems: navItems$ | async, currentPage: currentPage$ | async }; as data) {
            <div class="applications__paging">
                <app-paging [currentPage]="data.currentPage"
                            [pageCount]="data.pageCount"
                            [pagingNavItems]="data.navItems"
                            (onPageNav)="onPagignNavigation($event)"></app-paging>
            </div>
        }
    }
</div>
